import * as enUS from "./en-US.json";
import * as svSE from "./sv-SE.json";

export default { "en-US": enUS, "sv-SE": svSE };
